// import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { NotificationProvider } from "./context/NotificationContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import Login from "./components/Login/Login.jsx";
import ResetPasswordPage from "./components/Login/ResetPasswordPage.jsx";
import SalesExecutive from "./pages/SalesExecutive";
import AdminDashboard from "./pages/AdminDashboard.jsx";
import SaleDetails from "./pages/SaleDetails";
import DisplayProofDetails from "./pages/DisplayProofDetails";
import StockRequestDetails from "./pages/StockRequestDetails";
import VisitDetails from "./pages/VisitDetails";
import {
  ProtectedRoute,
  PublicOnlyRoute,
} from "./components/Auth/RouteGuards.jsx";
import ModeChooser from "./components/Auth/ModeChooser.jsx";
// import RecordSale from "./pages/RecordSale";

import "./styles/App.css";

const App = () => {
  return (
    <NotificationProvider>
      <CurrencyProvider>
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <PublicOnlyRoute>
                  <Login />
                </PublicOnlyRoute>
              }
            />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/select-mode"
              element={
                <ProtectedRoute allowedRoles={["promoter"]}>
                  <ModeChooser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/promoter"
              element={
                <ProtectedRoute allowedRoles={["promoter"]}>
                  <SalesExecutive />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sale-details"
              element={
                <ProtectedRoute allowedRoles={["promoter"]}>
                  <SaleDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/display-proof-details"
              element={
                <ProtectedRoute allowedRoles={["promoter"]}>
                  <DisplayProofDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stock-request-details"
              element={
                <ProtectedRoute allowedRoles={["promoter"]}>
                  <StockRequestDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/visit-details/:sessionGroupId"
              element={
                <ProtectedRoute allowedRoles={["promoter"]}>
                  <VisitDetails />
                </ProtectedRoute>
              }
            />
            {/* <Route path="/record-sale" element={<RecordSale />} /> */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute allowedRoles={["admin", "super_admin", "op"]} allowHeadPromoter>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </CurrencyProvider>
    </NotificationProvider>
  );
};

export default App;
